var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "buttonLink",
      class: [
        _vm.buttonColor,
        _vm.buttonSize,
        { isPc: !_vm.isSp, maxWidthNone: _vm.maxWidthNone },
      ],
      attrs: { href: _vm.buttonUrl, target: _vm.targetValue },
      on: {
        click: function ($event) {
          return _vm.clicked($event)
        },
      },
    },
    [
      _c("span", { staticClass: "buttonLinkText" }, [
        _vm._v(_vm._s(_vm.buttonText)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }